// Capitaliza la primera letra de un string y el resto en minúsculas
export function capitalize(str) {
  if (!str) return "";  
  return String(str).toLowerCase().split(" ").map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()).join(" ");
}

// Primera letra mayúscula y el resto minúsculas (formato oración)
export function toSentenceCase(str) {
  if (!str) return "";
  const value = String(str).trim();
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
